import { localStorageKeys } from '@/registry/local-storage-keys'

/**
 * スマホ表示時に切り替えられる一覧の列数。PC表示は常に4列でこの切替の対象外。
 * スマホの4列はカードに情報を載せる幅がないため、画像のみの表示になる(ProductCard側で切り替える)。
 */
// 列数の有限集合を数値リテラル型で表現するためのもので、マジックナンバーではない
// tslint:disable-next-line:no-magic-numbers
export type SpColumnCount = 2 | 3 | 4

export const SP_COLUMN_TWO: SpColumnCount = 2
export const SP_COLUMN_THREE: SpColumnCount = 3
export const SP_COLUMN_FOUR: SpColumnCount = 4

export const DEFAULT_SP_COLUMN_COUNT: SpColumnCount = SP_COLUMN_THREE

const STORAGE_KEY = localStorageKeys.hlItemlistSpColumnCount

export function isSpColumnCount(value: number): value is SpColumnCount {
  return value === SP_COLUMN_TWO || value === SP_COLUMN_THREE || value === SP_COLUMN_FOUR
}

/**
 * 直近に選んだ列数のlocalStorage永続化。
 * 画像種別(contact-lens-image-type-storage)と同様に、次回の一覧表示時のデフォルトへ引き継ぐ。
 */
export function loadSpColumnCount(): SpColumnCount {
  try {
    // 未保存(null)はNumberで0になり、列数として不正なのでデフォルトへのフォールバックに合流する
    const value = Number(localStorage.getItem(STORAGE_KEY))

    return isSpColumnCount(value) ? value : DEFAULT_SP_COLUMN_COUNT
  } catch {
    // localStorage が利用不可の場合はデフォルトの列数にフォールバック
    return DEFAULT_SP_COLUMN_COUNT
  }
}

export function saveSpColumnCount(count: SpColumnCount): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(count))
  } catch {
    // localStorage が利用不可の場合は無視
  }
}
